export default {"src":"/_next/static/media/stq.190eb975.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};